module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "dabef9d1bfb79-d1e251"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("Recent Titles by Glenis Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("BLOOD ON THE TURF")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("PHOTO FINISH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WEB OF EVASION")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOVE IN LAGANAS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE HONEY TREE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("ANGEL HARVEST")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("VENDETTA ")]), _vm._v(" "), _c('h4', {
    staticClass: "books-by-subtitle"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Harry Radcliffe series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("DEAD CERTAINTY *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("* "), _c('em', {
    staticClass: "italic "
  }, [_vm._v("available from Severn House")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b412ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106403_epub_alb.vue
// module id = 63
// module chunks = 0